export default () => ({
    ids: [],
    loading:false,
    userId: null,
});
